
export const common = {
  // Header
  "header.product": "Proizvod", 
  "header.features": "Karakteristike",
  "header.reviews": "Recenzije",
  "header.faq": "Česta pitanja",
  "header.buyNow": "Kupi sada",

  // Header (original continuation)
  // Header
  "header.home": "Početna",
  "header.product": "Proizvod", 
  "header.features": "Karakteristike",
  "header.reviews": "Recenzije",
  "header.faq": "Česta pitanja",
  "header.buyNow": "Kupi sada",

  // Hero Section
  "hero.flashSale": "Ograničena flash rasprodaja - 30% POPUSTA samo danas",
  "hero.title": "Osigurajte svoje",
  "hero.titleHighlight": "Parking mesto",
  "hero.subtitle": "Revolucionarna pametna parking barijera sa AI daljinskim upravljanjem. Pridružite se 10.000+ vlasnika nekretnina koji su zauvek zaustavili neovlašćeno parkiranje.",
  "hero.flashSaleEnds": "Flash rasprodaja se završava za:",
  "hero.hours": "Sati",
  "hero.minutes": "Minuti", 
  "hero.seconds": "Sekunde",
  "hero.buyNow": "Kupi sada - Samo €{price}!",
  "hero.freeShipping": "Dostava za 24-48h",
  "hero.guarantee": "30-dnevna garancija",
  "hero.rating": "4.8/5 Ocena",
  "hero.inStock": "Na stanju",
  "hero.quickInstall": "Brza instalacija",
  "hero.smartAI": "Pametna AI kontrola",
  "hero.appControl": "Kontrola aplikacijom",
  "hero.range": "100m domet",
  "hero.battery": "6 meseci",
  "hero.batteryLife": "Baterija",
  "hero.scrollExplore": "Skroluj da istražiš",

  // Problem/Solution Section
  "problem.badge": "Problem",
  "problem.title": "Umorno od neovlašćenog parkiranja?",
  "problem.stolenSpot": "Ukradeno parking mesto",
  "problem.stolenSpotDesc": "Dođete kući a neko je parkiran na vašem mestu",
  "problem.wastingTime": "Gubljenje vremena", 
  "problem.wastingTimeDesc": "Traženje parkinga po komšiluku svaki dan",
  "problem.losingMoney": "Gubljenje novca",
  "problem.losingMoneyDesc": "Plaćate parking dok drugi koriste vaše mesto",
  "problem.stress": "Stres i frustracija",
  "problem.stressDesc": "Svakodnevni konflikti sa neovlašćenim korisnicima",

  "solution.badge": "Rešenje",
  "solution.title": "Pametna parking barijera - Vaše rešenje!",
  "solution.protected": "100% zaštićeno mesto",
  "solution.protectedDesc": "Fizička barijera koja sprečava neovlašćeno parkiranje",
  "solution.oneClick": "Kontrola jednim klikom",
  "solution.oneClickDesc": "Podignite/spustite barijeru sa telefona do 100m daleko",
  "solution.noComplications": "Bez komplikacija",
  "solution.noComplicationsDesc": "Baterija traje 6 meseci, jednostavna instalacija",
  "solution.peace": "Mir i tišina",
  "solution.peaceDesc": "Nikad više stres zbog parkiranja",
  "solution.result": "Rezultat:",
  "solution.resultDesc": "Vaše parking mesto je uvek slobodno kada vam treba. Bez stresa, bez konflikata, bez gubljenja vremena!",

  // Features Section
  "features.badge": "Napredne karakteristike",
  "features.title": "Zašto je naša barijera najbolja?",
  "features.subtitle": "Kombinujemo najnoviju tehnologiju sa praktičnošću da vam damo savršeno rešenje za zaštićeno parking",
  "features.remoteControl": "Daljinska kontrola",
  "features.remoteControlDesc": "Kontrolišite barijeru sa telefona do 100 metara daleko. Jednostavna aplikacija za Android i iOS.",
  "features.longBattery": "Dugotrajna baterija",
  "features.longBatteryDesc": "Baterija traje do 6 meseci na jedno punjenje. Jednostavno punjenje preko USB kabla.",
  "features.weatherResistant": "Otporna na vremenske uslove",
  "features.weatherResistantDesc": "IP65 zaštita od kiše, snega i prašine. Radi na temperaturama od -20°C do +60°C.",
  "features.easyInstall": "Laka instalacija",
  "features.easyInstallDesc": "30-minutna instalacija bez profesionalne pomoći. Sve potrebno uključeno u paketu.",
  "features.smartAlarm": "Pametni alarm",
  "features.smartAlarmDesc": "Automatski alarm ako neko pokuša da pomeri barijeru bez dozvole. Obaveštenje na telefon.",
  "features.securityLock": "Sigurnosna brava",
  "features.securityLockDesc": "Automatsko zaključavanje u spuštenoj poziciji. Nemoguće pomeriti bez daljinske kontrole.",
  "features.ready": "Spremni da zaštitite svoje parking mesto?",
  "features.readyDesc": "Pridružite se hiljadama zadovoljnih korisnika koji nikad više nemaju probleme sa parkiranjem",
  "features.freeShipping": "Dostava za 24-48h",
  "features.warranty": "2 godine garancije",
  "features.moneyBack": "30 dana povraćaj novca",

  // Testimonials Section
  "testimonials.badge": "Hiljade nam veruje",
  "testimonials.title": "Pridružite se zadovoljnim kupcima",
  "testimonials.customers": "Zadovoljnih kupaca",
  "testimonials.rating": "Prosečna ocena",
  "testimonials.recommend": "Preporučuje prijateljima",
  "testimonials.reviews": "Pozitivnih recenzija",
  "testimonials.mark": "Konačno imam mir! Nema više stresa zbog parkiranja. Barijera radi savršeno već 8 meseci.",
  "testimonials.anna": "Najbolja investicija! Instalacija je bila super jednostavna, a baterija stvarno traje mesecima.",
  "testimonials.stefan": "Odličan proizvod! Aplikacija je intuitivna, a barijera je vrlo čvrsta. Preporučujem svima.",
  "testimonials.warranty2": "2 godine",
  "testimonials.warrantyText": "Garancija",
  "testimonials.free": "24-48h",
  "testimonials.shipping": "Dostava",
  "testimonials.support": "24/7",
  "testimonials.supportText": "Podrška",
  "testimonials.return": "30 dana",
  "testimonials.returnText": "Povraćaj",

  // Product Demo Section
  "demo.badge": "Pogledaj proizvod",
  "demo.title": "Pogledajte zašto je ovo najbolje rešenje",
  "demo.subtitle": "Istražite sve mogućnosti naše pametne parking barijere kroz interaktivnu prezentaciju",
  "demo.action": "U akciji",
  "demo.installation": "Instalacija",
  "demo.product": "Proizvod",
  "demo.howItWorks": "Pogledajte kako radi",
  "demo.simpleControl": "Jednostavna kontrola jednim dodirom na telefonu",
  "demo.distance": "Kontrola sa 100m udaljenosti",
  "demo.instant": "Trenutni odgovor barijere",
  "demo.silent": "Tiho i glatko funkcionisanje",
  "demo.led": "LED indikatori statusa",
  "demo.additional": "Dodatne informacije",
  "demo.additionalDesc": "Barijera se podiže za 3 sekunde i potpuno je tiha tokom rada.",
  "demo.tested": "Testirano",
  "demo.cycles": "10.000+ ciklusa",
  "demo.certified": "Sertifikovano",
  "demo.standards": "CE & IP65",

  // FAQ Section
  "faq.badge": "Često postavljana pitanja",
  "faq.title": "Imate pitanja? Mi imamo odgovore!",
  "faq.subtitle": "Evo odgovora na najčešća pitanja o našoj pametnoj parking barijeri",
  "faq.battery": "Koliko dugo traje baterija?",
  "faq.batteryAnswer": "Baterija traje do 6 meseci pri normalnom korišćenju (10-15 podizanja dnevno). Jednostavno se puni preko USB kabla.",
  "faq.install": "Da li je instalacija komplikovana?",
  "faq.installAnswer": "Ne! Instalacija traje oko 30 minuta i ne zahteva profesionalca. Sve potrebno je uključeno u paketu, uključujući alate i detaljno uputstvo.",
  "faq.phone": "Šta ako se telefon pokvari ili ostane bez baterije?",
  "faq.phoneAnswer": "Barijera ima manuelno otključavanje u slučaju hitnosti. Takođe, možete koristiti rezervni daljinski upravljač uključen u paketu.",
  "faq.weather": "Da li radi u svim vremenskim uslovima?",
  "faq.weatherAnswer": "Da! Barijera ima IP65 zaštitu i radi na temperaturama od -20°C do +60°C. Otporna je na kišu, sneg, prašinu i UV zračenje.",
  "faq.strong": "Koliko je jaka barijera?",
  "faq.strongAnswer": "Barijera može da izdrži pritisak do 2 tone. Napravljena je od visokokvalitetnog aluminijuma sa anti-korozivnim premazom.",
  "faq.multiple": "Mogu li da kontrolišem više barijera?",
  "faq.multipleAnswer": "Da! Aplikacija podržava kontrolu do 10 barijera istovremeno. Idealno za veće parking-lotove ili više parking mesta.",
  "faq.warranty": "Šta pokriva garancija?",
  "faq.warrantyAnswer": "Puna 2-godišnja garancija pokriva sve delove i rad. Takođe nudimo besplatnu tehničku podršku i zamenu delova.",
  "faq.return": "Mogu li da vratim proizvod ako nisam zadovoljan?",
  "faq.returnAnswer": "Apsolutno! Nudimo 30-dnevnu garanciju povraćaja novca bez pitanja. Ako niste 100% zadovoljni, vratićemo pun iznos.",
  "faq.stillQuestions": "Još uvek imate pitanja?",
  "faq.support": "Naš tim za podršku je dostupan 24/7 da odgovori na sva vaša pitanja",
  "faq.callUs": "Pozovite nas",
  "faq.sendEmail": "Pošaljite email",

  // Guarantee Section
  "guarantee.badge": "Naša garancija",
  "guarantee.title": "Kupujte bez rizika",
  "guarantee.subtitle": "Toliko verujemo u kvalitet našeg proizvoda da nudimo najjaču garanciju na tržištu",
  "guarantee.warranty2Years": "2 godine garancije",
  "guarantee.warranty2YearsDesc": "Potpuna zaštita na sve delove i rad. Besplatna zamena u slučaju defekta.",
  "guarantee.moneyBack30": "30 dana povraćaj novca",
  "guarantee.moneyBack30Desc": "Niste zadovoljni? Vratite proizvod i dobijte pun povraćaj.",
  "guarantee.lifetimeSupport": "Doživotna podrška",
  "guarantee.lifetimeSupportDesc": "24/7 tehnička podrška i pomoć tokom celog životnog veka proizvoda.",
  "guarantee.riskFree": "100% bez rizika",
  "guarantee.satisfaction": "Garantovano zadovoljstvo",
  "guarantee.riskFreeDesc": "Ako iz bilo kog razloga niste potpuno zadovoljni našom pametnom parking barijerom u prvih 30 dana, jednostavno je vratite i dobijte pun povraćaj. Bez pitanja, bez komplikacija.",
  "guarantee.freeShippingBoth": "Platite samo troškove povrata",
  "guarantee.moneyBack24": "Povraćaj novca za 24-48 sati",
  "guarantee.keepAccessories": "Zadržite sav pribor",
  "guarantee.noHiddenCosts": "Bez skrivenih troškova",
  "guarantee.days": "Dana",
  "guarantee.moneyBackGuarantee": "Povraćaj novca",
  "guarantee.guaranteed": "Garantovan povraćaj",
  "guarantee.testimonial": "Najbolja investicija koju sam napravio za svoje parkiranje. Barijera radi savršeno već godinu dana!",
  "guarantee.testimonialAuthor": "- Miloš Stojanović, Beograd",

  // Checkout Section
  "checkout.badge": "Ograničena ponuda - 30% POPUSTA",
  "checkout.title": "Izaberite svoj model",
  "checkout.subtitle": "Oba modela imaju iste karakteristike - razlika je samo u izvoru napajanja",
  "checkout.batteryModel": "Parking barijera na bateriju",
  "checkout.wiredModel": "Žični model",
  "checkout.batteryFeatures": [
    "Baterija traje 6 meseci",
    "USB punjenje",
    "Daljinska kontrola 100m",
    "Aplikacija za telefon",
    "IP65 zaštita",
    "2 godine garancije"
  ],
  "checkout.wiredFeatures": [
    "Direktno 220V napajanje",
    "Nikad se ne prazni",
    "Daljinska kontrola 100m",
    "Aplikacija za telefon", 
    "IP65 zaštita",
    "2 godine garancije"
  ],
  "checkout.yourOrder": "Vaša porudžbina",
  "checkout.quantity": "Količina:",
  "checkout.shipping": "Dostava",
  "checkout.free": "390 RSD",
  "checkout.total": "Ukupno:",
  "checkout.saved": "Uštedeli ste €{amount}!",
  "checkout.orderNow": "Naručite sada - €{price}",
  "checkout.securePayment": "Sigurno plaćanje sa SSL enkripcijom",
  "checkout.freeShipping2": "Dostava za 2-3 radna dana",
  "checkout.moneyBackGuarantee": "30 dana garancije povraćaja novca",
  "checkout.paymentMethods": "Prihvatamo sve glavne načine plaćanja:",

  // Floating CTA
  "cta.orderNow": "Naručite sada - Samo €{price}!",

  // Footer (original)
  "footer.description": "Vodeći proizvođač pametnih parking barijera sa daljinskim upravljanjem. Zaštitite svoje parking mesto najnovijom tehnologijom.",
  "footer.quickLinks": "Brzi linkovi",
  "footer.support": "Podrška",
  "footer.contact": "Kontakt",
  "footer.installation": "Instalacija",
  "footer.warranty": "Garancija",
  "footer.returns": "Povraćaji",
  "footer.technicalHelp": "Tehnička pomoć",
  "footer.copyright": "© 2024 ParkGuard. Sva prava zadržana.",
  "footer.terms": "Uslovi korišćenja",
  "footer.privacy": "Privatnost",
  "footer.websiteBuilder": "Website Builder",

  // Footer (modified)
  "footer.description": "Vodeći proizvođač pametnih parking barijera sa daljinskim upravljanjem. Zaštitite svoje parking mesto najnovijom tehnologijom.",
  "footer.quickLinks": "Brzi linkovi",
  "footer.support": "Podrška",
  "footer.contact": "Kontakt",
  "footer.installation": "Instalacija",
  "footer.warranty": "Garancija",
  "footer.returns": "Povraćaji",
  "footer.technicalHelp": "Tehnička podrška",
  "footer.copyright": "© 2025 ParkGuard. Sva prava zadržana.",
  "footer.terms": "Uslovi korišćenja",
  "footer.privacy": "Privatnost"
};

export default common;
